import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconDoor = (props) => {
    const { className, rootClassName } = props;
    const classes = classNames(rootClassName, className);

    return (
        <svg
            className={classes}
            width="32"
            height="30"
            viewBox="0 0 32 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.8825 1.16625e-05H4.59259C4.36632 -0.00105531 4.14578 0.0711156 3.96391 0.205742C3.78205 0.340368 3.64863 0.530223 3.58358 0.746942L0.176527 12.3178C-0.114021 13.2791 -0.0441372 14.3134 0.373087 15.2269C1.21436 17.0854 2.53309 18.6878 4.19502 19.871C5.85694 21.0541 7.80271 21.7757 9.8342 21.9624V27.2564H5.64091C5.36288 27.2564 5.09623 27.3669 4.89964 27.5635C4.70304 27.7601 4.59259 28.0267 4.59259 28.3047C4.59259 28.5828 4.70304 28.8494 4.89964 29.046C5.09623 29.2426 5.36288 29.3531 5.64091 29.3531H10.8825L10.8825 19.9214C9.06808 19.9214 7.29211 19.3982 5.76745 18.4145C4.2428 17.4308 3.03412 16.0283 2.28628 14.3751C2.07518 13.9147 2.03794 13.3933 2.18144 12.9075L2.52215 11.7805C3.96359 11.1384 6.63682 10.5881 10.4108 12.4751C10.5695 12.554 10.7268 12.6292 10.8825 12.7009V10.3626C7.66836 8.88553 5.08012 8.90575 3.24287 9.34319L5.37883 2.09666H10.8825V1.16625e-05ZM14.0811 29.0435H29.4331C29.9833 29.0435 30.5109 28.8249 30.8999 28.4359C31.289 28.0469 31.5075 27.5192 31.5075 26.969V18.5571C30.912 19.1708 30.2088 19.67 29.4331 20.03V26.969H14.0811V29.0435ZM14.0811 18.6704H21.135V20.1226C21.135 20.3976 21.2443 20.6615 21.4388 20.856C21.6333 21.0505 21.8971 21.1598 22.1722 21.1598C22.4473 21.1598 22.7111 21.0505 22.9057 20.856C23.1002 20.6615 23.2095 20.3976 23.2095 20.1226V14.4593H21.135V16.596H14.0811V18.6704ZM14.0811 6.22356H29.4331V13.4842C29.4331 14.3094 29.1052 15.1009 28.5217 15.6845C27.9381 16.268 27.1467 16.5958 26.3214 16.5958H25.2842V18.6703H26.3214C27.6968 18.6703 29.016 18.1239 29.9886 17.1513C30.9611 16.1787 31.5075 14.8596 31.5075 13.4842V5.18634C31.5075 4.91125 31.3983 4.64742 31.2037 4.45291C31.0092 4.25839 30.7454 4.14911 30.4703 4.14911H21.1353V2.4688C21.1243 1.80488 20.8508 1.17233 20.3745 0.709655C19.8982 0.24698 19.258 -0.00812405 18.594 0.000197372H14.0811V2.07465H18.6044C18.663 2.07327 18.7213 2.08345 18.7759 2.1046C18.8305 2.12575 18.8805 2.15746 18.9229 2.19792C18.9653 2.23837 18.9992 2.28678 19.0229 2.34038C19.0466 2.39398 19.0595 2.45171 19.0608 2.51029V4.14911H14.0811V6.22356ZM13.2011 0H11.4409V29.0423H13.2011V0Z"
                fill="#4A4A4A"
            />
        </svg>
    );
};

const { string } = PropTypes;

IconDoor.defaultProps = {
    className: null,
    rootClassName: null,
};

IconDoor.propTypes = {
    className: string,
    rootClassName: string,
};

export default IconDoor;
